// removed by extract-text-webpack-plugin
module.exports = {"button":"YroveG9F6YWfbnE6ozD90","newMessage":"_1HTo_skHXLMr6LaJMDkdcZ"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71b58899","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/rep-call/toolbar/live-coach-chat-button/live-coach-chat-button.less
// module id = mYRe
// module chunks = 1